import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { of } from 'rxjs';

import ptBR from '../assets/i18n/pt-BR.json';
import en from '../assets/i18n/en.json';

/**
 * Loader inline (SSR-safe): as traduções são bundladas e devolvidas de forma
 * SÍNCRONA, ficando disponíveis tanto no server quanto no client sem HTTP nem
 * TransferState. Evita flicker/mismatch de hidratação.
 */
const TRANSLATIONS: Record<string, Translation> = {
  'pt-BR': ptBR as Translation,
  en: en as Translation,
};

@Injectable({ providedIn: 'root' })
export class InlineTranslocoLoader implements TranslocoLoader {
  getTranslation(lang: string) {
    return of(TRANSLATIONS[lang] ?? TRANSLATIONS['pt-BR']);
  }
}
